__turbopack_context__.v({
  "largeInput": "SearchAutocomplete-module__zmZZnW__largeInput",
  "smallInput": "SearchAutocomplete-module__zmZZnW__smallInput",
});
